<template>
  <Modal
    data-testid="modal-reprocess-billet"
    title="Reprocessar boleto"
    :active.sync="active"
    @close="close"
  >
    <vs-alert
      title="Atenção!!"
      style="height: auto"
      active="true"
      color="danger"
    >
      Você tem certeza que deseja reprocessar o boleto?
    </vs-alert>
    <vs-button class="mt-4" color="success" @click="reprocessBillet">
      Confirmar
    </vs-button>
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import notify from '../../utils/notify';
import { PAYMENT_METHODS } from '../../utils/constants';
import paymentApi from '../../services/payment.api';

export default {
  name: 'ModalReprocessBillet',
  components: {
    Modal,
  },
  props: {
    activeProp: {
      type: Boolean,
      default: false,
    },
    gatewayIdProp: {
      type: String,
    },
  },
  watch: {
    activeProp: function (newValue) {
      this.active = newValue;
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    async reprocessBillet() {
      this.$vs.loading();
      await paymentApi
        .reprocessPayment(this.gatewayIdProp, PAYMENT_METHODS.BILLET.id)
        .then(async () => {
          this.$vs.loading.close();
          this.$emit('getInsuredBilletCharges');
          notify.notifySuccess(this.$vs, 'Boleto reprocessado com sucesso');
          this.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Erro ao reprocessar boleto';
          notify.notifyFail(this.$vs, errorMessage);
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped lang="scss">
.table-bordered {
  font-size: 1rem;
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
<style>
#credit-card-refund-history.con-vs-popup .vs-popup {
  width: fit-content !important;
  min-width: 60% !important;
}
</style>
